import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const createAccount = async <T extends Record<string, unknown>>({
  data,
  headers,
  domain,
  query,
}: FetchRequestArgs): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    data,
    domain,
    endpoint: `/hatch-elixir/onboarding/account-create`,
    headers,
    method: HTTPMethod.POST,
    query,
  });
